import { pubText, pubPath } from "../i18n/publicTranslation";
import React from 'react';
import { Button, SxProps, Theme } from '@mui/material';

export const FABLE_ONELINK_URL = 'https://thefableapp.onelink.me/wYsE/01djipro';

interface OneLinkDownloadButtonProps {
  label?: string;
  fullWidth?: boolean;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

const OneLinkDownloadButton: React.FC<OneLinkDownloadButtonProps> = ({
  label = 'Download Fable',
  fullWidth = false,
  onClick,
  sx,
}) => (
  <Button
    component="a"
    href={pubPath(FABLE_ONELINK_URL)}
    target="_blank"
    rel="noopener noreferrer"
    variant="contained"
    fullWidth={fullWidth}
    onClick={onClick}
    sx={{
      whiteSpace: 'nowrap',
      padding: '12px 32px',
      borderRadius: '999px',
      background: 'linear-gradient(135deg, #B56CFF 0%, #8A2BE2 45%, #5E0FB8 100%)',
      boxShadow: '0 10px 28px rgba(138, 43, 226, 0.38)',
      border: '1px solid rgba(255, 255, 255, 0.22)',
      color: '#fff',
      fontWeight: 700,
      fontSize: { xs: 16, sm: 17 },
      letterSpacing: 0,
      lineHeight: 1.2,
      textTransform: 'none',
      transition: 'all 0.25s ease',
      position: 'relative',
      overflow: 'hidden',
      minWidth: { xs: '230px', sm: '260px' },
      maxWidth: '360px',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 14px 36px rgba(138, 43, 226, 0.5)',
        background: 'linear-gradient(135deg, #C084FC 0%, #9333EA 45%, #6D28D9 100%)',
      },
      '&:active': {
        transform: 'translateY(1px)',
        boxShadow: '0 5px 14px rgba(138, 43, 226, 0.35)',
      },
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '50%',
        background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0.28), rgba(255, 255, 255, 0))',
        borderRadius: '999px 999px 0 0',
        pointerEvents: 'none',
      },
      ...sx,
    }}
  >
    {pubText(label)}
  </Button>
);

export default OneLinkDownloadButton;
